'use strict';

// the "module" is a special internal dependency which is used to retrieve custom values for the
// basket (if any)
define(['jquery', 'common', 'app', 'siteObj', 'handlebars', 'handlebarsHelper', 'ajaxBasketTemplate', 'ajaxBasketTemplateErr', 'ajaxBasketTemplateInit', 'ajaxBasketTemplateTop', 'ajaxBasketTemplateRecommendations', 'ajaxBasketTemplateUpgrade', 'module', 'jqueryHelper'], function ($, common, app, siteObj, handlebars, handlebarsHelper, ajaxBasketTemplate, ajaxBasketTemplateErr, ajaxBasketTemplateInit, ajaxBasketTemplateTop, ajaxBasketTemplateRecommendations, ajaxBasketTemplateUpgrade, module) {

  // START PRODUCT VARIATION

  // Header Basket and Popup handling
  var utils = siteObj.fn;
  var basket_utils = utils.basket;
  var fb_defaults = {
    'closeBtn': module.config().fb_closeBtn || false,
    'height': module.config().fb_height || 'autoSize',
    'width': module.config().fb_width || 600,
    'minWidth': module.config().fb_minWidth || 350,
    'maxWidth': module.config().fb_maxWidth || 980,
    'minHeight': module.config().fb_minHeight || 20,
    'margin': module.config().fb_margin || 0,
    'padding': module.config().fb_padding || 0,
    helpers: {
      overlay: {
        opacity: module.config().fb_overlayOpacity || 0.2
      }
    }
  };
  // maximum number of recommendations to show in the basket
  var maxRecommendations = module.config().maxRecommendations || 4;
  // size of the thumbnail being shown in the basket popup
  var thumbnailImageSize = module.config().thumbnailImageSize || 'thumbnail';
  // basket container class for basket shown in the fancyBox overlay
  var basketContainerClass = module.config().basketContainerClass || 'basketAlert';
  // the Close button container class (used to close fancyBox overlay)
  var fb_CloseBtnClass = module.config().fb_CloseBtnClass || 'close-fb';
  // class of the element on page that contains the top basket (with info about items
  // count and price)
  var basketHeaderClass = module.config().basketHeaderClass || 'header-basket';
  // same as above, however this is used when on-page basket container does not have class
  // (but has an ID)
  var basketHeaderID = module.config().basketHeaderID || false;
  // class of the element holding items count in the top basket
  // var basketQuantityClass = module.config().basketQuantityClass || 'basket-item-qty';
  // class of the element containing top basket content - including items count and other
  // possible texts ... used for content replace purposes when a basket item is added
  var basketItemsContainerClass = module.config().basketItemsContainerClass || 'basket-items';
  // class of the parent element containing title for recommendations and the
  // recommendations element itself
  var recommendationsParentClass = module.config().recommendationsParentClass || 'panel-content:first';
  // class of the actual header element containing title for recommendations
  var recommendationsHeaderClass = module.config().recommendationsHeaderClass || 'panel-head';
  // class of the element containing product recommendations on current page that can be
  // added to the basket overlay
  var recommendationsClass = module.config().recommendationsClass || 'panel-content:first';
  var rrp = module.config().rrp || false;
  // Initial HTML markup to be added into Fancybox. Contains the loading spinner and
  // hidden close button.
  var initial_fb_content = ajaxBasketTemplateInit({
    'basketContainerClass': basketContainerClass,
    'props': siteObj.props,
    'loadingGifPath': siteObj.loadingGifPath
  });
  // alternative CSS seletor for subtotal and title classes
  var altTitleSelector = module.config().altTitleSelector || 'size-2of5';
  var altSubtotalSelector = module.config().altTitleSelector || 'size-3of5';
  // if set, the recommendations header text will be enclosed in this element
  var recommendationsHeaderEncloseElement = module.config().recommendationsHeaderEncloseElement || null;

  basket_utils.init_add = function (product_id, item_qty, button, variations) {
    variations = variations || '0'; // Default variations to "0" if none have been passed in.

    // "this" refers to the "basket" object within the siteObj.
    var url = this.build_add_url(product_id, item_qty, variations);

    // Extra options for Fancybox to be merged with the defaults later on.
    var fb_opts = {
      afterShow: function afterShow() {
        // Calls the update_products() function to initiate the Ajax request
        // passing it the relevant URL once Fancybox is completely displayed.

        basket_utils.update_products(url, button);
        // Bind close events to the "Continue Shopping" button and "Close..." link.
        $('.' + basketContainerClass).on('click', '.' + fb_CloseBtnClass, function (e) {
          $.fancybox.close();
          e.preventDefault();
        });
      },
      beforeClose: function beforeClose() {
        $('.' + basketContainerClass).off('click', '.' + fb_CloseBtnClass);
        if ($('body:not(.product)').length) {
          siteObj.productID = null;
        }
      }
    };

    basket_utils.qty_added = item_qty;

    // Initiate Fancybox to show the loading icon to the user asap.
    // Also, merges new settings with the default settings defined above.
    if (!$('.secureqv').length && $().fancybox) {
      $.fancybox(initial_fb_content, $.extend({}, fb_opts, fb_defaults));
    }

    // User is on the basket page and experiment is set
    if ($('.secureqv').length && siteObj.page === 'basket') {
      basket_utils.update_products(url, button);
    }
  };

  // This is called from common.js when the Ajax request is complete. Here we
  // fire off functions to update the on page basket and give the user
  // visual feedback that the item has been added, usually by updating a
  // popup, sliding the product down in the basket or some other form of animation.
  basket_utils.init_basket_update = function (data, error) {
    // var popupContent;
    error = error || false;

    // Error handling...
    if (typeof data === 'string' && error) {
      utils.log(error);
      this.update_basket_popup(ajaxBasketTemplateErr({
        'errorMessage': data,
        'showContinueBtn': module.config().basketShowErrorContinueBtn,
        'props': siteObj.props
      }));
    } else {
      if ($.isPlainObject(data)) {
        data = data.simpleBasket;

        var item_details = data.lastAddedItem;
        // Passes the "data" object to a function where it is processed
        // and the necessary HTML for the basket popup is then returned

        var popup_content = this.build_basket_popup_content(data);

        // Update the on page basket.
        this.update_page_basket(data);
        // Update globalBasketItemsCount component
        app.publish('ajaxBasket/updateGlobalBasketItemsCount', data.totalUnits);

        // Populate the basket popup with generated HTML from the
        // build_basket_popup_content() function based on the product that was last added to
        // the basket.
        this.update_basket_popup(popup_content);

        // basket upgrade offer UK only
        var basketUpgradeSwitch = siteObj.features.basketUpgrade;
        var customerLocation = siteObj.customerLocation;
        var threshold = data.threshold;
        var basketUpgradeSku = data.basketUpgradeSku;
        var basketUpgradeItemInBasket = data.basketUpgradeItemInBasket;
        var basketUpgradeRejected = data.basketUpgradeRejected;
        var offerTitle = '';
        var offerMessage = '';

        if (data.hasOwnProperty('basketUpgradeMessage')) {
          offerTitle = data.basketUpgradeMessage.ajaxBasketTitle;
          offerMessage = data.basketUpgradeMessage.ajaxBasketMessage;
        }

        if (basketUpgradeSwitch === true && customerLocation === 'GB' && threshold !== '' && basketUpgradeItemInBasket === false && !basketUpgradeRejected) {
          this.apply_basket_upgrade(basketUpgradeSku, threshold, offerTitle, offerMessage);
        }

        // if we should show recommendations, do so here
        if (!module.config().hideRecommendations && siteObj.page !== 'basket') {
          this.apply_basket_popup_cross_sell(item_details.productURL, item_details.childMasterProductId === 0 ? item_details.productId : item_details.childMasterProductId);
        }
      } else {
        // we can reuse the error message HTML, as it has the same structure as we use for
        // showing extended basket data
        this.update_basket_popup(ajaxBasketTemplateErr({
          'errorMessage': data
        }));
      }
    }
  };

  // Update the onpage basket in the header.
  basket_utils.update_page_basket = function (data) {

    var $basket = $(basketHeaderID ? '#' + basketHeaderID : '.' + basketHeaderClass);
    var qty = data.totalUnits;
    // Decodes &pound; to be £.
    var price = $('<span />').html(data.totalprice).text();

    // catch page changes which have removed header-basket css class in favour of data selector
    if (!$basket.length) {
      $basket = $('*[data-target="header-basket"]');
    }

    // Set basket and price into session storage to preserve after back button is pressed.

    // no need to do anything if the basket container is not on the page (Lipton's case)
    if ($basket.length) {
      $basket.find('.' + basketItemsContainerClass).empty().append(ajaxBasketTemplateTop({
        'quantity': qty,
        'basketTitle': siteObj.props.ajaxBasket.titles.basketTitle,
        'basketItemsTitle': qty > 1 ? siteObj.props.ajaxBasket.titles.basketItems : siteObj.props.ajaxBasket.titles.basketItem,
        'basketTotalPrice': price,
        'basketSubTotalPrice': price,
        'basketURL': siteObj.siteBasketURL,
        'viewBasketTitle': siteObj.props.ajaxBasket.titles.basketView,
        'checkoutBtnTitle': siteObj.props.ajaxBasket.titles.basketViewCheckoutBtnTitle,
        'props': siteObj.props
      }));

      // update number of items manually here, as it's not part of the top template
      // when its alternative class is passed via a config parameter
      if (module.config().basketQuantityClass) {
        var basketQuantityElement = $('.' + module.config().basketQuantityClass);
        if (basketQuantityElement) {
          basketQuantityElement.text(qty);
          if (qty > 0) {
            basketQuantityElement.removeClass('basketQtyHidden');
          } else {
            basketQuantityElement.addClass('basketQtyHidden');
          }
        }
      }
    }
  };

  // Updates the contents of the Fancybox basket popup
  // based on a string of HTML which we pass to it.
  basket_utils.update_basket_popup = function (html) {

    // Set up a "contents" variable we use to add the html into
    // and set as hidden until we're ready to append and use it.
    var contents = $('<div />', {
      'html': html,
      'css': {
        'display': 'none'
      }
    });
    // Some faster references to DOM elements.
    var $fb_content = $('.fancybox-wrap .' + basketContainerClass + ':last');
    var $loading = $fb_content.find('.fb-loader');

    $fb_content
    // Add in the contents.
    .append(contents).children('div:last').slideDown('fast', function () {
      // Re-centre the Fancybox window once the contents have been shown.
      $.fancybox.reposition();

      //resize if additional content is injected
      $.fancybox.update();

      // Remove the loading icon.
      $loading.hide();
    });
  };

  // Generates the HTML to add into the Fancybox popup
  // based on the data we receive from the Ajax request.
  basket_utils.build_basket_popup_content = function (data) {
    var qty = data.totalUnits;
    var item = data.lastAddedItem;
    var alertError = '';
    // var r_valid_img = /\.(jpg|png|gif)$/;
    // Builds up the product name based on whether the
    // product has a primaryContributor (artist) or not.

    if (data.lastAddedQuantity === 0 && data.lastAddedQuantityRequested > 0) {
      alertError = '<div class="alert alert-error">Items cannot be added to your basket. This product is limited to a quantity of ' + data.lastAddedItem.maxPerOrder + ' per order.</div>';
    }

    if (data.lastAddedQuantity > 0 && data.lastAddedQuantityRequested > 0 && data.lastAddedQuantity < data.lastAddedQuantityRequested) {
      alertError = '<div class="alert alert-warning">' + Number(data.lastAddedQuantityRequested - data.lastAddedQuantity) + ' items cannot be added to your basket. This product is limited to a quantity of ' + data.lastAddedItem.maxPerOrder + ' per order.</div>';
    }

    var collection = {
      simpleBasket: {
        lastAddedItem: {
          quantity: data.lastAddedQuantity,
          productTitle: item.primaryContributor !== '' && typeof item.primaryContributor !== 'undefined' ? item.primaryContributor + ' - ' + item.productTitle : item.productTitle,
          productURL: siteObj.siteNonSecureURL + item.productURL,
          price: item.price,
          productImages: siteObj.productImagePrefix + item.productImages[thumbnailImageSize]
        },

        totalUnits: qty > 1 ? qty + ' ' + siteObj.props.ajaxBasket.titles.basketItems : qty + ' ' + siteObj.props.ajaxBasket.titles.basketItem,
        totalPrice: data.totalprice,
        basketSize1: altTitleSelector,
        basketSize2: altSubtotalSelector,
        excludeTick: module.config().excludeTick || false,
        addedItemToBasket: data.lastAddedQuantity > 1 ? siteObj.props.ajaxBasket.titles.addedItemsToBasket : siteObj.props.ajaxBasket.titles.addedItemToBasket,
        quantityText: ' ' + (data.lastAddedQuantity > 1 ? siteObj.props.ajaxBasket.titles.basketItems : siteObj.props.ajaxBasket.titles.basketItem)
      },
      closeBtnTitle: module.config().altCloseTitle ? module.config().altCloseTitle : siteObj.props.ajaxBasket.titles.basketClose,
      props: siteObj.props,
      basketURL: siteObj.siteBasketURL,
      rrp: rrp ? siteObj.rrp.split(';')[1].split('<')[0] > item.price.split(';')[1] ? siteObj.rrp : '' : '',
      errorMessage: alertError
    };

    // alternative popup content is used on the Lipton site
    if (module.config().altPopupContent) {
      //html.push(altContent);
    }

    return ajaxBasketTemplate(collection);
  };

  // Gets basket upgrade sku and adds it into the Fancybox popup if user is eligible for a
  // free product.
  basket_utils.apply_basket_upgrade = function (basketUpgradeSku, threshold, offerTitle, offerMessage) {

    $.ajax({
      cache: false,
      type: 'POST',
      url: siteObj.siteNonSecureURL + 'product.json?productId=' + basketUpgradeSku,
      dataType: 'json',
      success: function success(result) {
        var count = 0;
        for (var prop in result) {
          if (result.hasOwnProperty(prop)) {
            count++;
          }
        }
        if (count) {
          handleBasketUpgradeResult(result);
        }
      }
    });

    function handleBasketUpgradeResult(result) {

      basket_utils.update_basket_popup(ajaxBasketTemplateUpgrade({
        'productId': result.id,
        'productTitle': result.title,
        'productThumb': result.thumbnailImage,
        'offerTitle': offerTitle,
        'offerMessage': offerMessage,
        'offerThreshold': threshold,
        'offerAcceptedButtonText': siteObj.features.basketUpgradeButtons.offerAcceptedButtonText,
        'offerDeclinedButtonText': siteObj.features.basketUpgradeButtons.offerDeclinedButtonText,
        'siteCode': siteObj.siteCode,
        'cdnPath': siteObj.siteCDNPath
      }));
    }
  };

  // Gets any recommendation products from the product page for
  // the last added product and adds them into the Fancybox popup.
  basket_utils.apply_basket_popup_cross_sell = function (url, product_id) {

    // Find the recommendations panel.
    var $productDiv = $('.product');
    var recommendations = $productDiv.find('.' + recommendationsParentClass);

    // Check if we're on the product page for the product we've just added,
    // so we can just copy the HTML for the panel rather than use Ajax to get it.
    if (window.location.href.match(product_id + '')) {
      // Uses + "" to convert to string.
      // Check there's products to add.
      if (recommendations.find('.item').length) {
        // Update the basket popup with the relevant HTML.
        var header = recommendations.find('.' + recommendationsHeaderClass).html();
        if (recommendationsHeaderEncloseElement) {
          header = '<' + recommendationsHeaderEncloseElement + '>' + header + '</' + recommendationsHeaderEncloseElement + '>';
        }

        this.update_basket_popup(ajaxBasketTemplateRecommendations({
          'props': siteObj.props,
          'header': header,
          'content': recommendations.find('.' + recommendationsClass).slice(0, maxRecommendations).map(function () {
            return $(this).outerHTML();
          }).get().join('')
        }));
      }
    } else {
      //This calls the recommendations that have been stored as data on the body tag in the
      // list-recommendations.js, if available
      var contents = $('body').data('recommendations');
      if (contents) {
        basket_utils.update_basket_popup(contents);
      } else {
        // If not, make an Ajax request to the page.
        $.ajax({
          url: siteObj.siteNonSecureURL + url,
          type: 'get',
          dataType: 'html',
          success: function success(data) {
            data = $(data);
            // Check there's products to add.
            recommendations = data.find('div').closest('.' + recommendationsParentClass);
            if (recommendations.length) {
              // a dirty hack, as "data.find('.' + recommendationsParentClass)" does
              // not work here at all with AJAX and 1.8 version of jQuery
              var header = recommendations.find('.' + recommendationsHeaderClass).html();

              if (recommendationsHeaderEncloseElement) {
                header = '<' + recommendationsHeaderEncloseElement + '>' + header + '</' + recommendationsHeaderEncloseElement + '>';
              }

              // Update the basket popup with the relevant HTML.
              basket_utils.update_basket_popup(ajaxBasketTemplateRecommendations({
                'props': siteObj.props,
                'header': header,
                'content': recommendations.find('.' + recommendationsClass).slice(0, maxRecommendations).map(function () {
                  return $(this).outerHTML();
                }).get().join('')
              }));
            } else {
              utils.log('No recommendations available for this product.');
            }
          }
        });
      }
    }
  };
  // END PRODUCT VARIATION

  // Functionality for the basket upgrade offer buttons inside ajax basket
  var $document = $(document);

  $document.on('click', '.bu-offer-declined', function () {
    var link = $(this).attr('data-href');

    $.ajax({
      cache: false,
      type: 'GET',
      url: link,
      success: function success() {
        $('.ajax-basket-offer').remove();
      }
    });
  });

  $document.on('click', '.bu-offer-accepted', function () {
    var link = $(this).attr('data-href');
    var basketUpgradeSkuId = $(this).data('product-id');
    var basketUpgradeSkuTitle = $(this).data('product-title');

    $.ajax({
      cache: false,
      type: 'POST',
      url: link,
      success: function success() {
        app.publish('tracking/record', 'Basket Overlay', 'Clicked Add to Basket', basketUpgradeSkuTitle + ' | ' + basketUpgradeSkuId);
        $('.ajax-basket-offer').remove();
      }
    });
  });
});
//# sourceMappingURL=ajax-basket.js.map
